<template>
    <div class="fs-toolbar mb-2">

        <!-- BACK -->
        <!-- <button>
            <i class="fa fa-caret-left"></i>
            <span class="text">Back</span>
        </button> -->

        <!-- FORWARD -->
        <!-- <button>
            <i class="fa fa-caret-right"></i>
            <span class="text">Forward</span>
        </button> -->

        <!-- UP -->
        <button @click="goUpDirectory">
            <i class="fa fa-folder"></i>
            <span class="text">Up</span>
        </button>

        <!-- HOME -->
        <button @click="goHome">
            <i class="fa fa-home"></i>
            <span class="text">Home</span>
        </button>

        <!-- NEW FOLDER -->
        <!-- <button>
            <i class="fa fa-folder-o"></i>
            <span class="text">New Folder</span>
        </button> -->

        <!-- DELETE -->
        <!-- <button class="ml-auto">
            <i class="fa fa-times-circle"></i>
            <span class="text">Delete</span>
        </button> -->

        <!-- VIEWS -->
        <button class="ml-auto" @click="switchView">
            <i v-show="!iconView" class="fa fa-th-large"></i>
            <i v-show="iconView" class="fa fa-list"></i>
            <span class="text">Views</span>
        </button>

    </div>
</template>

<script>
    // import { mapGetters } from 'vuex';

    export default {
        components: {

        },
        props: {
            directoryBreadcrumbs: {
                type: Array,
                required: true
            },
            iconView: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {

            }
        },
        computed: {
            // ...mapGetters('gameOS', {

            // }),
        },
        created() {

        },
        methods: {
            goHome() {
                this.$emit('goHome');
            },
            goUpDirectory() {
                const crumbs = this.directoryBreadcrumbs;
                const prevCrumb = crumbs[crumbs.length-2];
                if (prevCrumb.path !== '/') {
                    this.$emit('goUpDirectory', prevCrumb.node);
                }
            },
            switchView() {
                this.$emit('setIconView');
            }
        }
    }
</script>

<style lang="scss" scoped>

    //-----------------------------------------------------------------
    // TOOLBAR
    //-----------------------------------------------------------------

    .fs-toolbar {
        display: flex;
        overflow: hidden;
    }

    .fs-toolbar button {
        min-width: rem-calc(60);
        height: rem-calc(60);
        border: 1px solid transparent;
        font-size: rem-calc(14);
        background: none;
        transition: none;
        overflow: hidden;

        .fa {
            display: block;
            margin-bottom: rem-calc(5);
            font-size: rem-calc(17);
        }

        .text {
            white-space: nowrap;
        }

        &:hover {
            // background: rgba(black, 0.03);
                // background: rgba(white, 0.1);
                // border: 1px solid rgba(black, 0.1);
            // box-shadow: 1px 1px 2px 1px rgba(black, 0.02);
            border: 1px solid rgba(white, 0.5);
            border-right: 1px solid rgba(black, 0.09);
            border-bottom: 1px solid rgba(black, 0.09);
        }

        &:active {
            background: rgba(black, 0.015);
            border: 1px solid rgba(white, 0.2);
            border-top: 1px solid rgba(black, 0.1);
            border-left: 1px solid rgba(black, 0.1);

            .fa,
            .text {
                position: relative;
                top: 1px;
                left: 1px;
            }
        }
    }
</style>